import { Modal, Popover, Tooltip } from '@mui/material';
import { IOSSwitch } from '../../../components/IOSSwitch';
import axios from 'axios';
import { RenameQuery } from './RenameQuery';
import { FiltersContainer } from '../Filters/FiltersContainer';
import play_icon from '../../../assets/images/play_icon.svg';
import eye_icon from '../../../assets/images/eye_icon.svg';
import edit_icon from '../../../assets/images/edit_icon.svg';
import filter_icon from '../../../assets/images/filter_icon.svg';
import lightbulb_icon from '../../../assets/images/lightbulb_icon.svg';
import { useState, useEffect } from 'react';
import { UpgradeModal } from '../../../components/UpgradeModal/UpgradeModal';
import { useAuth0 } from '@auth0/auth0-react';
import { AutoRefreshStatus } from './AutoRefreshStatus';

export const EvScreenControlButtonsMobile = (props) => {
	const {
		isMobile,
		isScannable,
		executeEvScreen,
		setIsAutoRefresh,
		isAutoRefresh,
		lastRefreshedAt,
		isLive,
		setIsFiltersOpen,
		setIsFiltersSetAnchorEl,
		setIsLive,
		setIsFilterSetOpen,
		isFilterSetOpen,
		isFilterSetModalOpen,
		setIsFilterSetModalOpen,
		user,
		setUser,
		isFiltersSetAnchorEl,
		queries,
		setQueries,
		setFilters,
		newQueryName,
		setNewQueryName,
		newQueryNameRef,
		edit_icon,
		setFiltersOpen,
		filtersOpen,
		setIsPlacedUnplacedOpen,
		setIsPlacedAnchorEl,
		isPlacedUnplacedOpen,
		allBetsOpen,
		setAllBetsOpen,
		isPlacedAnchorEl,
		isFiltersOpen,
		// Sorting props
		order,
		setOrder,
		orderBy,
		setOrderBy,
	} = props;

	useEffect(() => {
		const handleEscapeKey = (event) => {
			if (event.key === 'Escape') {
				setIsFiltersOpen(false);
				setFiltersOpen(null);
				setIsPlacedUnplacedOpen(false);
				setIsSortingOpen(false);
			}
		};

		document.addEventListener('keydown', handleEscapeKey);

		return () => {
			document.removeEventListener('keydown', handleEscapeKey);
		};
	}, [setIsFiltersOpen, setFiltersOpen, setIsPlacedUnplacedOpen]);
		console.log('filtersOpen: ', filtersOpen);

	const isMasterOrOracle =
		(user?.stripe_plan?.nickname?.includes('Visionary') && user?.stripe_plan.active&& user?.stripe_subscription !== null && user?.stripe_status !== 'deleted' && user.stripe_status !== 'past_due') ||
		(user?.stripe_plan?.nickname?.includes('Oracle') && user?.stripe_plan.active&& user?.stripe_subscription !== null && user?.stripe_status !== 'deleted' && user.stripe_status !== 'past_due');
	const [isUpgradeModalOpen, setIsUpgradeModalOpen] = useState(false);
	const [isSortingOpen, setIsSortingOpen] = useState(false);
	const [sortingAnchorEl, setSortingAnchorEl] = useState(null);
	const {  getAccessTokenSilently } = useAuth0();

	return (
		<div style={{ width: '100%', paddingLeft: '8px', paddingRight: '8px', boxSizing: 'border-box' }}>
			{/* Top row: Pregame/Live, All Bets, Customize */}
			<div style={{ 
				display: 'flex', 
				flexDirection: 'row', 
				gap: '6px', 
				width: '100%', 
				marginTop: '8px', 
				alignItems: 'stretch',
				boxSizing: 'border-box'
			}}>
				{/* Pregame/Live Toggle */}
				<div className="flex flex-row rounded-xl filter-button2" style={{ 
					flex: 1, 
					height: '44px', 
					alignItems: 'center', 
					justifyContent: 'center',
					maxWidth: 'calc(40% - 3px)',
					padding: '4px'
				}}>
					<div 
						onClick={() => setIsLive(false)} 
						className={`cursor-pointer ${!isLive && 'filter-button-highlighted'}`} 
						style={{ 
							height: '36px', 
							display: 'flex', 
							alignItems: 'center', 
							padding: '0 12px',
							fontSize: '13px',
							fontWeight: '500',
							borderRadius: '0.75rem',
							transition: 'all 0.2s ease'
						}}>
						Pregame
					</div>
					<div
						onClick={() => {
							if (isMasterOrOracle) {
								setIsLive(true);
							} else {
								setIsUpgradeModalOpen(true);
							}
						}}
						className={`cursor-pointer ${isLive && 'filter-button-highlighted'}`}
						style={{ 
							height: '36px', 
							display: 'flex', 
							alignItems: 'center',
							padding: '0 12px',
							fontSize: '13px',
							fontWeight: '500',
							borderRadius: '0.75rem',
							transition: 'all 0.2s ease'
						}}>
						Live
					</div>
					<UpgradeModal isOpen={isUpgradeModalOpen} setIsOpen={setIsUpgradeModalOpen} />
				</div>

				{/* All Bets Dropdown */}
				<div
					onClick={(e) => {
						setIsPlacedAnchorEl(e.currentTarget);
						setIsPlacedUnplacedOpen(!isPlacedUnplacedOpen);
					}}
					className="flex flex-row filter-button cursor-pointer"
					style={{ 
						flex: 1, 
						height: '44px',
						alignItems: 'center', 
						justifyContent: 'center', 
						borderRadius: '0.75rem',
						borderBottomLeftRadius: isPlacedUnplacedOpen ? 0 : '0.75rem',
						borderBottomRightRadius: isPlacedUnplacedOpen ? 0 : '0.75rem',
						minWidth: '80px',
						maxWidth: 'calc(30% - 3px)',
						background: '#22262e',
						transition: 'all 0.2s ease-in-out',
						boxShadow: '0 1px 4px rgba(0,0,0,0.1)',
						padding: '0 12px'
					}}>
					<img width={16} src={lightbulb_icon} alt="icon" style={{ opacity: 0.9, marginRight: '6px' }} />
					<div style={{ fontSize: '12px', fontWeight: '500', color: '#fff', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
						{allBetsOpen === 'all' && 'All'}
						{allBetsOpen === 'unplaced' && 'Unplaced'}
						{allBetsOpen === 'placed' && 'Placed'}
					</div>
				</div>

				<Popover
					anchorEl={isPlacedAnchorEl}
					open={isPlacedUnplacedOpen}
					onClose={() => {
						setIsPlacedUnplacedOpen(false);
					}}
					sx={{
						'& .MuiPaper-root': {
							backgroundColor: '#22262e',
							borderTopRightRadius: '0.75rem',
							borderBottomLeftRadius: '0.75rem',
							borderBottomRightRadius: '0.75rem',
							boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
						},
					}}
					anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
					transformOrigin={{ vertical: 'top', horizontal: 'center' }}>
					<div className="rounded-xl" style={{ backgroundColor: '#22262e', width: 120 }}>
						<div
							onClick={() => {
								setAllBetsOpen('all');
								setIsPlacedUnplacedOpen(false);
							}}
							className={`p-3 filter-button cursor-pointer ${allBetsOpen === 'all' && 'filter-button-highlighted'}`}
							style={{ 
								color: 'white', 
								borderTopLeftRadius: '0.75rem', 
								borderTopRightRadius: '0.75rem',
								fontSize: '12px',
								fontWeight: '500',
								transition: 'background-color 0.2s ease'
							}}>
							All Bets
						</div>
						<div
							onClick={() => {
								setAllBetsOpen('unplaced');
								setIsPlacedUnplacedOpen(false);
							}}
							className={`p-3 filter-button cursor-pointer ${allBetsOpen === 'unplaced' && 'filter-button-highlighted'}`}
							style={{ 
								color: 'white',
								fontSize: '12px',
								fontWeight: '500',
								transition: 'background-color 0.2s ease'
							}}>
							Unplaced
						</div>
						<div
							onClick={() => {
								setAllBetsOpen('placed');
								setIsPlacedUnplacedOpen(false);
							}}
							className={`p-3 filter-button cursor-pointer ${allBetsOpen === 'placed' && 'filter-button-highlighted'}`}
							style={{ 
								color: 'white', 
								borderBottomLeftRadius: '0.75rem', 
								borderBottomRightRadius: '0.75rem',
								fontSize: '12px',
								fontWeight: '500',
								transition: 'background-color 0.2s ease'
							}}>
							Placed
						</div>
					</div>
				</Popover>

				{/* Customize Button */}
				<div
					onClick={() => {
						setIsFiltersOpen(!isFiltersOpen);
						setFiltersOpen(filtersOpen ? null : 'website');
					}}
					className={`filter-button rounded-xl cursor-pointer flex flex-row ${isFiltersOpen && 'filter-button-highlighted'} filter-button-tutorial`}
					style={{ 
						flex: 1, 
						height: '44px', 
						alignItems: 'center', 
						justifyContent: 'center', 
						padding: '0 16px', 
						maxWidth: 'calc(30% - 3px)'
					}}>
					<img src={filter_icon} alt="filter icon" style={{ width: 16, height: 16, marginRight: '6px' }} />
					<div style={{ fontSize: '12px', fontWeight: '500' }}>Customize</div>
				</div>
			</div>

			{/* Second row: Scan and Auto Refresh (left side) and Sort (right side) */}
			<div style={{ 
				display: 'flex', 
				flexDirection: 'row', 
				alignItems: 'center', 
				justifyContent: 'space-between',
				marginTop: '12px', 
				width: '100%',
				boxSizing: 'border-box'
			}}>
				{/* Left side controls - Scan and Auto Refresh */}
				<div style={{ 
					display: 'flex', 
					flexDirection: 'row', 
					gap: '8px',
					flex: '0 0 auto'
				}}>
					{/* Scan button */}
					<Tooltip title={!isScannable ? `Finish selecting filters.` : ''}>
						<button
							onClick={async () => {
								if (isScannable) {
									setFiltersOpen(false)
									await executeEvScreen();
								}
							}}
							style={{
								cursor: isScannable ? 'pointer' : 'default',
								width: '100px',
								height: '44px',
								display: 'flex',
								alignItems: 'center',
								justifyContent: 'center',
								background: isScannable ? 'linear-gradient(90deg, #1e6ffc 0%, #2879ff 100%)' : '#363844',
								border: 'none',
								borderRadius: '0.75rem',
								padding: '0 16px',
								fontSize: '14px',
								color: 'white',
								fontWeight: '600',
								boxShadow: isScannable ? '0 2px 8px rgba(30,111,252,0.15)' : 'none',
								transition: 'all 0.2s ease',
								whiteSpace: 'nowrap'
							}}>
							<span style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
								<img src={play_icon} alt="play icon" style={{ width: 18, height: 18, marginRight: '8px' }} />
								<span>Scan</span>
							</span>
						</button>
					</Tooltip>
					<div style={{ position: 'relative' }}>
						<button
							onClick={() => {
								if (!isMasterOrOracle) {
									setIsUpgradeModalOpen(true);
									return;
								}
								setIsAutoRefresh(!isAutoRefresh);
							}}
							style={{
								display: 'flex',
								alignItems: 'center',
								justifyContent: 'center',
								height: '44px',
								paddingLeft: '12px',
								paddingRight: '12px',
								border: isMasterOrOracle && isAutoRefresh ? '2px solid #0064f2' : '2px solid #444',
								borderRadius: '0.75rem',
								background: isMasterOrOracle && isAutoRefresh ? '#1e3a5f' : 'transparent',
								color: isMasterOrOracle && isAutoRefresh ? '#ffffff' : '#b1b6c3',
								fontWeight: '500',
								fontSize: '12px',
								transition: 'all 0.2s ease',
								outline: 'none',
								boxShadow: 'none',
								cursor: 'pointer',
								whiteSpace: 'nowrap',
								minWidth: '80px',
								maxWidth: '100px'
							}}>
							Auto Refresh
						</button>
						<div style={{ position: 'absolute', top: '100%', left: 0, right: 0, display: 'flex', justifyContent: 'center' }}>
							<AutoRefreshStatus isAutoRefresh={isMasterOrOracle && isAutoRefresh} lastRefreshedAt={lastRefreshedAt} compact />
						</div>
					</div>
				</div>

				{/* Right side controls - Sort */}
				<div style={{ 
					display: 'flex', 
					flexDirection: 'row', 
					gap: '8px',
					flex: '0 0 auto'
				}}>
					{/* Sort dropdown - wider with larger font */}
					<div
						onClick={(e) => {
							setSortingAnchorEl(e.currentTarget);
							setIsSortingOpen(!isSortingOpen);
						}}
						className="flex flex-row filter-button cursor-pointer"
						style={{ 
							height: '44px',
							alignItems: 'center', 
							justifyContent: 'center', 
							borderRadius: '0.75rem',
							borderBottomLeftRadius: isSortingOpen ? 0 : '0.75rem',
							borderBottomRightRadius: isSortingOpen ? 0 : '0.75rem',
							minWidth: '110px',
							maxWidth: '130px',
							background: '#22262e',
							transition: 'all 0.2s ease-in-out',
							boxShadow: '0 1px 4px rgba(0,0,0,0.1)',
							padding: '0 12px'
						}}>
						<div style={{ fontSize: '12px', fontWeight: '500', color: '#fff', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', lineHeight: '1.1' }}>
							{orderBy === 'ev' ? 'Sort by EV%' : orderBy === 'game' && order === 'asc' ? 'Sort by Earliest' : 'Sort by Latest'}
						</div>
					</div>
				</div>

				<Popover
					anchorEl={sortingAnchorEl}
					open={isSortingOpen}
					onClose={() => {
						setIsSortingOpen(false);
					}}
					sx={{
						'& .MuiPaper-root': {
							backgroundColor: '#22262e',
							borderTopRightRadius: '0.75rem',
							borderBottomLeftRadius: '0.75rem',
							borderBottomRightRadius: '0.75rem',
							boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
						},
					}}
					anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
					transformOrigin={{ vertical: 'top', horizontal: 'right' }}>
					<div className="rounded-xl" style={{ backgroundColor: '#22262e', width: 140 }}>
						<div
							onClick={() => {
								setOrderBy('ev');
								setOrder('desc');
								setIsSortingOpen(false);
							}}
							className={`p-3 filter-button cursor-pointer ${orderBy === 'ev' && 'filter-button-highlighted'}`}
							style={{ 
								color: 'white', 
								borderTopLeftRadius: '0.75rem', 
								borderTopRightRadius: '0.75rem',
								fontSize: '12px',
								fontWeight: '500',
								transition: 'background-color 0.2s ease'
							}}>
							Sort by EV%
						</div>
						<div
							onClick={() => {
								setOrderBy('game');
								setOrder('asc');
								setIsSortingOpen(false);
							}}
							className={`p-3 filter-button cursor-pointer ${orderBy === 'game' && order === 'asc' && 'filter-button-highlighted'}`}
							style={{ 
								color: 'white',
								fontSize: '12px',
								fontWeight: '500',
								transition: 'background-color 0.2s ease'
							}}>
							Sort by Earliest
						</div>
						<div
							onClick={() => {
								setOrderBy('game');
								setOrder('desc');
								setIsSortingOpen(false);
							}}
							className={`p-3 filter-button cursor-pointer ${orderBy === 'game' && order === 'desc' && 'filter-button-highlighted'}`}
							style={{ 
								color: 'white', 
								borderBottomLeftRadius: '0.75rem', 
								borderBottomRightRadius: '0.75rem',
								fontSize: '12px',
								fontWeight: '500',
								transition: 'background-color 0.2s ease'
							}}>
							Sort by Latest
						</div>
					</div>
				</Popover>
			</div>
		</div>
	);
};
